import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "react-js-pagination";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";

const Packages = () => {
  const [fatchdata, setFatchdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchData = async () => {
    try {
      const response = await thirdparty.get(
        "/packages/get_package_list?show_hidden=1"
      );
      if (response.status === 200) {
        setFatchdata(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const togglePackageStatus = async (item) => {
    const newStatus = item.status === "1" ? "0" : "1";
    const data = {
      package_id: item.id,
      status: newStatus,
    };

    try {
      const response = await thirdparty.post(
        `packages/update_status_packages/${item.id}`,
        data
      );
      if (response.status === 200) {
        toast.success("Status updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setFatchdata((prev) =>
          prev.map((pkg) =>
            pkg.id === item.id ? { ...pkg, status: newStatus } : pkg
          )
        );
      } else {
        toast.error("Failed to update status", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const handleDelete = async (id) => {
    try {
      let confirmation = confirm("Are you sure to delete this item?");
      if (!confirmation) {
        return;
      }
      const response = await thirdparty.delete(
        `/packages/delete_package/${id}`
      );
      if (response.status === 200) {
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        fetchData();
      }
    } catch (error) {
      console.error(`Error deleting item with ID ${id}:`, error.message);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filteredData =
      fatchdata &&
      fatchdata.filter((item) =>
        Object.values(item).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    setFilteredData(filteredData);
  }, [fatchdata, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="row page-content-wrapper">
              <div className="card p-0">
                <div className="card-header row">
                  <div className="col-md-8">
                    <h5 className="card-title text-left">Packages</h5>
                  </div>
                  <div className="col-md-2 text-right">
                    <input
                      className="form-control"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      value={searchTerm}
                      onChange={handleSearch}
                      style={{
                        background: "transparent",
                        border: "none",
                      }}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <a href="/addpackage" className="btn btn-primary">
                      Add New
                    </a>
                  </div>
                </div>
                <div className="card-body">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Age Range</th>
                        <th scope="col">Gender</th>
                        {/* <th scope="col">Status</th> */}
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((item) => (
                          <tr key={item.id}>
                            <th>{item.id}</th>
                            <td>{item.name}</td>
                            <td>{item.department_name}</td>
                            <td>{item.age}</td>
                            <td>{item.gender}</td>
                            {/* <td>
                              <button
                                className={`btn ${
                                  item.status === "1"
                                    ? "btn-success"
                                    : "btn-danger"
                                }`}
                                onClick={() => togglePackageStatus(item)}
                              >
                                {item.status === "1" ? (
                                  <i className="fa fa-check"></i>
                                ) : (
                                  <i className="fa fa-times"></i>
                                )}
                              </button>
                            </td> */}
                            <td>
                              {/* <a className="ms-0" href={`/viewpackage/${item.id}`}>
                                <i className="fa  fa-laptop  display-4"></i>
                              </a> */}
                              <a className="ms-2"
                                title="Status"
                                onClick={() => togglePackageStatus(item)}
                              >
                                {item.status === "1" ? (
                                  <i class="fa-solid fa-eye"></i>
                                ) : (
                                  <i class="fa-solid fa-eye-slash"></i>
                                )}
                              </a>
                              <a className="ms-2" href={`/editpackage/${item.slug}`}>
                                <i class="fa-solid fa-pencil-square"></i>
                              </a>
                              <a className="ms-2" onClick={() => handleDelete(item.id)}>
                                <i
                                  className="fa fa-trash display-4"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Delete Request"
                                ></i>
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="100%" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={filteredData ? filteredData.length : 1}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Packages;


// WEBPACK FOOTER //
// ./src/component/admin/packages.js